import React, { memo } from "react"
import { TooltipIcon, TimeAgo } from ".."
import { usePersonAccreditationStatusStyles } from "./PersonAccreditationStatus"
import { USER_ACCREDITATIONS_STATUS } from "../../data"

const PersonAccreditationItemStatus = memo(function PersonAccreditationItemStatus({ userAccreditation, onClick }) {
  const { status, statusAt, expiresAt } = userAccreditation
  const classes = usePersonAccreditationStatusStyles({ statusAt })

  const handleClick = () => {
    onClick && onClick(userAccreditation)
  }

  if (status === USER_ACCREDITATIONS_STATUS.WARNING) {
    return (
      <TooltipIcon
        tooltip={
          <>
            Expiring soon <TimeAgo date={expiresAt} />
          </>
        }
        name="warning"
        className={classes.expiring}
        refClassName={classes.iconRef}
        onClick={handleClick}
      />
    )
  }
  if (status === USER_ACCREDITATIONS_STATUS.EXPIRED) {
    return (
      <TooltipIcon
        tooltip={
          <>
            Expired <TimeAgo date={expiresAt} />
          </>
        }
        name="warning"
        className={classes.expired}
        refClassName={classes.iconRef}
        onClick={handleClick}
      />
    )
  }
  if (status === USER_ACCREDITATIONS_STATUS.AWAITING) {
    return (
      <TooltipIcon
        tooltip={
          <>
            Awaiting upload <TimeAgo date={statusAt} />
          </>
        }
        name="accreditations-awaiting"
        className={classes.awaiting}
        refClassName={classes.iconRef}
        onClick={handleClick}
      />
    )
  }

  return (
    <TooltipIcon
      tooltip="Up to date"
      name="accreditations-compliant"
      className={classes.compliant}
      refClassName={classes.iconRef}
      onClick={handleClick}
    />
  )
})

export { PersonAccreditationItemStatus }
